import axios from "axios";
import { ApiKey, BaseUrl } from "../global";

export const getLocations = async (uid, accountNo, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/user/Locations' + `?uid=${uid}&accountNo=${accountNo}`, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

export const accountsLocations = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/user/AccountsLocations', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

export const getPages = async (uid, source) => {
    try {
        //const rs = await axios.get(BaseUrl + 'api/user/UserPages' + `?uid=${uid}`, {
        const rs = await axios.get(BaseUrl + 'api/user/getMenus' + `?id=${uid}`, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

export const saveSubAccount = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/CreateSubAccount', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const saveSubAccountLogo = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/SaveSubaccountLogo', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const saveUser = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/SaveUser', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const getBranches = async (source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/Branches', {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const getBranchesAccountNo = async (accountNo, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/getBranchesAccountNo?accountNo='+ accountNo , {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const getDestinations = async (source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/Destinations', {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const getAreas = async (locid) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/Areas?locationid=' + locid, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const saveLocation = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/SaveLocation', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const updateLocation = async (lid, data, source) => {
    try {
        const rs = await axios.post(BaseUrl + `api/User/updateLocations?lid=${lid}`, data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const forgetPassword = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/ForgetPassword', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const resetPassword = async (userid) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/ResetPassword?userid=' + userid, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getAllServices = async () => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/GetAllServices', {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getAccountServices = async (accounts) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/GetAccountServices', accounts, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}


export const saveService = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/SaveService', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}


export const saveLocationShop = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/SaveLocationShop', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}


export const kpiIntervals = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/KPIIntervals', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const updateKPIInterval = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/UpdateKPIInterval', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getUsers = async (uid) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/GetUsers?uid=' + uid, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}


export const getSubAaccounts = async (uid, isActive) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/GetSubAaccounts' + `?uid=${uid}&isActive=${isActive}`  , {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getSubAccountApprovalStatuses = async (uid) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/GetSubAccountApprovalStatuses', {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getLocs = async (uid) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/GetLocations?uid=' + uid, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const CreateUser = async (data) => {
    try {
        debugger
        const rs = await axios.post(BaseUrl + 'api/User/CreateUser', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data.msg;
    } catch (e) {
        console.log(e);
        return e;
    }
}

export const getCustomerInfo = async (branchCode, AccountNo) => {
    try {
        const rs = await axios.get(BaseUrl + `api/User/getCustomerInformation?branchCode=${branchCode}&accountNumber=${AccountNo}`, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getCITarrifOne = async (AccountNo) => {
    try {
        const rs = await axios.get(BaseUrl + `api/User/GetTarrif2New?accountNo=${AccountNo}`, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const UpdateBankDetails = async (queryParam, data) => {
    try {
        debugger
        const rs = await axios.post(BaseUrl + `api/User/updateBankDetails?branchCode=${queryParam.branchCode}&accountNo=${queryParam.accountNo}`, data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return e;
    }
}

export const getBanks = async () => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/getBanks', {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e }
    }
}

export const getEmailNotificationType = async () => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/getEmailNotificationType', {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e }
    }
}

export const getEmailNotification = async (accNo) => {
    try {
        const rs = await axios.get(BaseUrl + `api/User/getEmailNotification?accountNo=${accNo}`, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e }
    }
}

export const SaveEmailNotification = async (data) => {
    try {
        debugger
        const rs = await axios.post(BaseUrl + 'api/User/saveEmailNotification', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return e;
    }
}

export const UpdateEmailNotification = async (data) => {
    try {
        debugger
        const rs = await axios.post(BaseUrl + 'api/User/updateEmailNotification', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return e;
    }
}

export const inActiveEmailNotifications = async (uid) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/inActiveEmailNotification?id=' + uid, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getEmailNotificationSubaccout = async (uid) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/getEmailNotificationSubaccout?id=' + uid, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getMultipleSubAccountLocations = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/user/getMultipleSubAccountLocations', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

export const getSubAccountLocations = async (uid, accountNo, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/user/getsubAccountLocations' + `?subAccountId=${accountNo}&userId=${uid}`, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

export const getSubAaccountsEmailNotifications = async (uid) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/GetSubAaccountsEmailNotifications?uid=' + uid, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getUserSubAccounts = async (userId) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/getUserSubAccounts?userId=' + userId, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const updateUser = async (uid, data, source) => {
    try {
        const rs = await axios.post(BaseUrl + `api/User/UpdateUser?id=${uid}`, data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const validateUser = async (userId) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/validateUser?userId=' + userId, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const updateMergeAccount = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/updateMergeAccount', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const saveMergeAccount = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/MergeUsers', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}


export const getMergeAccountLocation = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/getMergeAccountLocation', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}


export const getAccountMergeUsers = async (uid) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/getMergeUser?uid=' + uid, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}